import { DropdownOption } from 'components/final-form/dropdownUtils';
import React, { Component } from 'react';
import { MessageSourceProps, withMessages } from 'react-message-source';
import { Grid } from 'semantic-ui-react';
import { Field } from 'react-final-form';
import { CostEstimationDto } from 'ts-types/api.types';
import Select from 'components/final-form/Select';
import moment from 'moment';
import { getAllPatientCostEstimationsByTariffId } from 'services/costEstimationServices';
import { noop } from 'utils/functionUtils';
import axios, { CancelTokenSource } from 'axios';
import { EditTreatmentValues } from 'components/treatments/TreatmentsContext';

interface Props extends MessageSourceProps {
  tariffId: number,
  tariffs: Array<DropdownOption>,
  costEstimations: Array<CostEstimationDto>,
  patientId: number,
  treatment: EditTreatmentValues,
  readOnly: boolean
}

interface State {
  costEstimations: Array<DropdownOption>,
  cancelTokenSource: CancelTokenSource
}

class CostEstimationDropdown extends Component<Props, State> {

  constructor(props: Props) {
    super(props);

    const cancelTokenSource = axios.CancelToken.source();

    this.state = {
      costEstimations: this.mapToDropdownCostEstimationOptions(props.costEstimations, props.tariffId),
      cancelTokenSource
    }

  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {

    const {costEstimations, tariffId, patientId, treatment} = this.props;
    const {cancelTokenSource} = this.state;

    const emptyCostEstimation =
        {
          key: -1,
          text: "",
          value: -1
        };

    if (prevProps.costEstimations !== costEstimations) {

      const costEstimationOptions = this.mapToDropdownCostEstimationOptions(costEstimations, tariffId);

      this.setState({
        costEstimations: [emptyCostEstimation, ... costEstimationOptions]
      })
    }

    if (prevProps.tariffId !== tariffId) {
      getAllPatientCostEstimationsByTariffId(patientId, tariffId, cancelTokenSource)
          .then(response => {

            const filteredCostEstimations =
                response.filter(ce => !ce.used || (treatment && treatment.costEstimationId && ce.id === treatment.costEstimationId));

            const costEstimationOptions = this.mapToDropdownCostEstimationOptions(filteredCostEstimations, tariffId)

            this.setState({
              costEstimations: [emptyCostEstimation, ...costEstimationOptions]
            })
          })
          .catch(noop)
    }

  }

  mapToDropdownCostEstimationOptions = (costEstimations: Array<CostEstimationDto>, tariffId: number): Array<DropdownOption> => {

    const {tariffs} = this.props;

    let costEstimationOptions: Array<DropdownOption> = [];

    costEstimations.forEach((costEstimation) => {

      let tariff: DropdownOption | undefined;

      tariff = tariffs.find(t => t.value === tariffId);

      if (tariff) {
        const option: DropdownOption = {
          key: costEstimation.id.toString(),
          text: `${moment(costEstimation.estimationDate).format("DD.MM.YYYY")} ${tariff.text} `,
          value: costEstimation.id
        }

        costEstimationOptions.push(option);
      }
    })

    return costEstimationOptions;

  }

  render() {

    const {getMessage, readOnly} = this.props;
    const {costEstimations} = this.state;

    return (
        <Grid.Row>
          <Grid.Column width={8}>
          </Grid.Column>
          <Grid.Column width={3}>
            {getMessage('costEstimation')}
          </Grid.Column>
          <Grid.Column width={5}>
            <Field
                name='costEstimationId'
                component={Select}
                options={costEstimations}
                disabled={readOnly}
                fluid
            />
          </Grid.Column>
        </Grid.Row>
    );
  }
};

export default withMessages(CostEstimationDropdown);
